export class Endpoints {
    url?: string;
    remoteUrl?: string;
    frontendUrl?: string;
}

export class Paths {
    dataDir?: string;
    staticFilePath?: string;
    productReleasePath?: string;
    resourceFileLocation?: string;
    trainedModelsPath?: string;
    logDirectory?: string;
    encryptionKeysLocation?: string;
}

export class AppConfig {
    companyName?: string;
    endpoints?: Endpoints = new Endpoints();
    paths?: Paths = new Paths();
    aspNetEnvironmentName?: string;
    supportedCultures: string[] = [];
}
